module.exports = __webpack_public_path__ + "media/images/offers-select-62a6048e3a48b57469f14ce912b99d81.svg";